var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_643_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99877 15.5C9.89058 15.5 9.78532 15.4649 9.69877 15.4L7.69877 13.9C7.63667 13.8534 7.58627 13.793 7.55156 13.7236C7.51684 13.6542 7.49877 13.5776 7.49877 13.5V10.69L3.99077 6.7435C3.74163 6.46244 3.57896 6.11541 3.52231 5.74412C3.46566 5.37283 3.51744 4.99308 3.67143 4.65051C3.82542 4.30794 4.07507 4.01713 4.39036 3.81303C4.70565 3.60894 5.07318 3.50024 5.44877 3.5H12.5488C12.9243 3.50044 13.2918 3.60932 13.6069 3.81355C13.9221 4.01779 14.1716 4.30869 14.3254 4.65129C14.4792 4.9939 14.5308 5.37364 14.4741 5.74487C14.4173 6.11611 14.2545 6.46305 14.0053 6.744L10.4988 10.69V15C10.4988 15.1326 10.4461 15.2598 10.3523 15.3536C10.2586 15.4473 10.1314 15.5 9.99877 15.5ZM8.49877 13.25L9.49877 14V10.5C9.49887 10.3776 9.54388 10.2594 9.62527 10.168L13.2593 6.0795C13.3804 5.94254 13.4595 5.77352 13.487 5.59273C13.5145 5.41193 13.4892 5.22705 13.4142 5.06028C13.3391 4.89351 13.2176 4.75193 13.0641 4.65254C12.9106 4.55316 12.7316 4.50019 12.5488 4.5H5.44877C5.266 4.50028 5.08718 4.55327 4.93377 4.65263C4.78036 4.75199 4.65887 4.8935 4.58387 5.06018C4.50887 5.22685 4.48355 5.41163 4.51093 5.59234C4.53832 5.77305 4.61725 5.94203 4.73827 6.079L8.37277 10.168C8.45398 10.2595 8.49881 10.3776 8.49877 10.5V13.25Z",
    fill: "#0090D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_643_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(3 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.368e4173c827684336536324dd78b974.svg";
export { ForwardRef as ReactComponent };